import React, { useState } from 'react'
import Wrapper from '../Wrapper'
import { Image, Text, View } from 'react-native'
import { Link } from '../../../ui/atoms/Link'
import { useStore } from '../../../store'
import { useResponsive } from '../../../utils/hooks'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { isWeb } from '../../../utils/helpers/commonUtils'
import walletIcon from '../../../assets/icons/Wallet.svg'
import accountIcon from '../../../assets/icons/Account.svg'
import TCicon from '../../../assets/icons/TermsConditions.svg'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { paths } from '../../links'
import { useTranslation } from 'react-i18next'
import { urls } from '@linqpal/models/src/dictionaries'
import { ConfirmationModal } from '../../Supplier/SupplierConsole/Components/ConfirmationModal'

const row1 = [
  {
    name: 'Wallet',
    icon: walletIcon,
  },
  {
    name: 'Account',
    icon: accountIcon,
  },

  // comented for a while
  // {
  //   name: 'Referrals',
  //   icon: referralIcon,
  // },
  {
    name: 'Terms & Conditions',
    icon: TCicon,
    action: () => {
      if (isWeb) {
        window.open(urls.TC, '_blank')
      }
    },
  },
]

const MoreHeader = () => {
  const { t } = useTranslation('global')
  return (
    <View
      style={{ padding: 20, justifyContent: 'center', alignItems: 'center' }}
    >
      <Text style={{ fontWeight: '600', fontSize: 18 }}>{t('More.more')}</Text>
    </View>
  )
}

const MoreItem = ({ navigation, page }) => {
  return (
    <TouchableOpacity
      onPress={() =>
        page.action
          ? page.action()
          : navigation.push(page.path || paths.Console.More[page.name])
      }
      style={{
        width: 98,
        height: 98,
        border: page.name && '1px solid #E6EBEE',
        borderRadius: 12,
        alignItems: 'center',
        marginTop: 15,
      }}
    >
      <View>
        <Image
          style={{ width: 32, height: 32, marginTop: 18, marginBottom: 6 }}
          source={page.icon}
        />
      </View>

      <Text
        style={{
          fontSize: 12,
          textAlign: 'center',
          paddingTop: 5,
          fontWeight: '500',
          lineHeight: 15,
          color: commonColors.textDark,
        }}
      >
        {page.name}
      </Text>
    </TouchableOpacity>
  )
}

export const More = ({ navigation }) => {
  const { t } = useTranslation('global')
  const { screenHeight } = useResponsive()
  const store = useStore()
  const [showLogoutAlert, setShowLogoutAlert] = useState(false)

  return (
    <Wrapper toolbar={<MoreHeader />}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          marginTop: 35,
          width: '100%',
          flexWrap: 'wrap',
        }}
      >
        {row1.map((page, i) => (
          <MoreItem key={page.name} navigation={navigation} page={page} />
        ))}
      </View>

      <View style={{ marginTop: screenHeight - 500 }}>
        <Link
          title={t('More.log_out')}
          color="#DA515E"
          textStyle={{ fontSize: 15 }}
          onPress={() => setShowLogoutAlert(true)}
        />
      </View>

      <ConfirmationModal
        visible={showLogoutAlert}
        onConfirm={() => store.logOut()}
        onClose={() => setShowLogoutAlert(false)}
      />
    </Wrapper>
  )
}
